import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/sonner';
import AppShell from '@/components/AppShell';
import RequireAuth from '@/components/RequireAuth';
import Login from '@/pages/Login';
import Signup from '@/pages/Signup';
import Dashboard from '@/pages/Dashboard';
import Agents from '@/pages/Agents';
import AgentDetail from '@/pages/AgentDetail';
import Tasks from '@/pages/Tasks';
import TaskDetail from '@/pages/TaskDetail';
import Templates from '@/pages/Templates';
import Proxies from '@/pages/Proxies';
import Workers from '@/pages/Workers';
import Credentials from '@/pages/Credentials';
import ApiKeys from '@/pages/ApiKeys';
import Analytics from '@/pages/Analytics';
import Settings from '@/pages/Settings';
import Billing from '@/pages/Billing';
import Master from '@/pages/Master';
import Schedules from '@/pages/Schedules';
import Identities from '@/pages/Identities';
import AutomationDocs from '@/pages/AutomationDocs';
import ErrorBoundary from '@/components/ErrorBoundary';
import '@/App.css';

const qc = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 15_000 } },
});

function App() {
  React.useEffect(() => { document.documentElement.classList.add('dark'); }, []);
  return (
    <ErrorBoundary>
      <QueryClientProvider client={qc}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route element={<RequireAuth><AppShell /></RequireAuth>}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/master" element={<Master />} />
              <Route path="/master/:sessionId" element={<Master />} />
              <Route path="/agents" element={<Agents />} />
              <Route path="/agents/:agentId" element={<AgentDetail />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/tasks/:taskId" element={<TaskDetail />} />
              <Route path="/schedules" element={<Schedules />} />
              <Route path="/identities" element={<Identities />} />
              <Route path="/templates" element={<Templates />} />
              <Route path="/proxies" element={<Proxies />} />
              <Route path="/workers" element={<Workers />} />
              <Route path="/credentials" element={<Credentials />} />
              <Route path="/api-keys" element={<ApiKeys />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/docs" element={<AutomationDocs />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="bottom-right" theme="dark" />
      </div>
    </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
